import React from 'react';

import i18n from '@client/utils/i18n';
import { RecipeSection } from '@ledium/types';
import { Description, LediumForm, TitleAndDescription, UniqueName } from '@ledium/ui-common';
import { RecipeEditorSections } from '@ledium/ui-dashboard';
import { Container } from '@mui/material';

import RecipeEditorAddNewButton from './Components/RecipeEditorAddNewButton';
import RecipeEditorSectionEditor, { SectionFormRef } from './Components/RecipeEditorSectionEditor';

interface RecipeEditorViewProps {
    onSave: () => void;
    onClose: () => void;
    selectedSection: RecipeSection | null;
    setSelectedSection: (section: RecipeSection | null) => void;
    onSaveSection: (sectionData: RecipeSection, options?: { recipeSave: false }) => void;
    onDeleteSection: (sectionData: RecipeSection) => void;
}

const RecipeEditorView = ({ onSave, selectedSection, setSelectedSection, onSaveSection, onDeleteSection, onClose }: RecipeEditorViewProps) => {
    const formRef = React.useRef<SectionFormRef>(null);

    return (
        <Container>
            <LediumForm
                saveText={i18n('save_recipe')}
                onSubmit={() => onSave()}
                onCancel={onClose}
                showButtons={true}
                formRef={formRef}
                header={<TitleAndDescription />}
            >
                <UniqueName />
                <Description />
                <RecipeEditorSections setSelectedSection={setSelectedSection} />
                <RecipeEditorAddNewButton setSelectedSection={setSelectedSection} />
            </LediumForm>

            <RecipeEditorSectionEditor
                selectedSection={selectedSection}
                setSelectedSection={setSelectedSection}
                formRef={formRef}
                onSaveSection={onSaveSection}
                onDeleteSection={onDeleteSection}
            />
        </Container>
    );
};

export default RecipeEditorView;
